<span>{{name}}</span>
<span>
  <i class='fa fa-pencil-square-o' data-action='edit'></i>
</span>
